import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { ListTurfComponent } from './list-turf/list-turf.component';



const routes: Routes = [
  {
    path: '',
    component: ListTurfComponent,
  },

  { path: '', pathMatch: 'full', redirectTo: 'admin/turf' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TurfRoutingModule { }
